import Gas from '@/models/Gas'
import User, { hasRole, Role } from '@/models/User'

export default class GasPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, gas: Gas) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === gas.entry.catalog.company.id
			case Role.AUDITOR:
				return gas.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, gas: Gas) {
		return hasRole(user, Role.USER) && user.company?.id === gas.entry.catalog.company.id
	}

	restore(user: User, gas: Gas) {
		return hasRole(user, Role.USER) && user.company?.id === gas.entry.catalog.company.id
	}

	delete(user: User, gas: Gas) {
		return hasRole(user, Role.USER) && user.company?.id === gas.entry.catalog.company.id
	}

	forceDelete(_user: User, _gas: Gas) {
		return false
	}
}
